
//############################################################################################
//# axboot.initView
//############################################################################################

axboot.initView = (function () {
    // 우측 상단 공통버튼 초기화
    var __initPageButton = function (fnObj) {
        fnObj['pageButtonView'] = axboot.viewExtend({
            initView: function () {
                axboot.buttonClick(this, 'data-page-btn', { });

                /*
                axboot.buttonClick(this, 'data-page-btn', {
                    'search' : function () {
                        ACTIONS.dispatch(ACTIONS.search);
                    },
                    'add' : function () {
                        ACTIONS.dispatch(ACTIONS.add);
                    },
                    'save' : function () {
                        ACTIONS.dispatch(ACTIONS.save);
                    },
                    'remove' : function () {
                        ACTIONS.dispatch(ACTIONS.remove);
                    }
                });
                */
            }
        });
    }

    // 폼 초기화
    var __initFormView = function (fnObj) {
        $('form').each(function (index, element) {
            var formId = $(element).attr('id');

            if (!ax5.util.isNothing(formId)) {
                // Form init
                var objForm = axboot.viewExtend(axboot.formView, {
                    getDefaultData: function () {
                        return $.extend({}, axboot.formView.defaultData, {
                        });
                    },
                    initView: function () {
                        this.target = $(element);
                        this.model = new ax5.ui.binder();
                        this.model.setModel(this.getDefaultData(), this.target);
                        this.modelFormatter = new axboot.modelFormatter(this.model);

                        this.initBinding();
                        this.initEvent();
                    },
                    initBinding: function () {
                        // 바인딩 타겟 목록
                        var aryBindingTarget = axboot.util.getBindingTargets(this.target);
                        var that = this;

                        for (var i = 0; i < aryBindingTarget.length; i++) {
                            if (fnObj.hasOwnProperty(aryBindingTarget[i])) {
                                var $targetObject = fnObj[aryBindingTarget[i]].target;

                                // key event 바인딩
                                this.target.find(':input').on('keyup change click', function () {
                                    var axPath = $(this).data('axPath');

                                    if (!ax5.util.isNothing(axPath)) {
                                        var selectedIndex = -1;
                                        var selectedDataIndexs = $targetObject.selectedDataIndexs;

                                        if (selectedDataIndexs.length > 0) {
                                            selectedIndex = selectedDataIndexs[selectedDataIndexs.length - 1];
                                            $targetObject.setValue(selectedIndex, axPath, $(this).val());

                                            if ($(this).is('select')) {
                                                $targetObject.setValue(selectedIndex, $(this).data('axPathText'), $(this).find('option:selected').text());
                                            }

                                            that.bindEvent();
                                        }
                                    }
                                });
                            }
                        }
                    },
                    initEvent : function () {

                    },
                    bindEvent : function () {

                    },
                    clear: function () {
                        this.model.setModel(this.getDefaultData());
                        this.modelFormatter = new axboot.modelFormatter(this.model);
                    },
                    setData: function (data) {
                        if (typeof data === 'undefined') {
                            data = this.getDefaultData();
                        }

                        data = $.extend({}, data);

                        this.setModelData(data);

                        this.model.setModel(data);
                        this.modelFormatter.formatting();

                        this.setDataFinished(data);
                    },
                    setModelData: function (data) {

                    },
                    setDataFinished: function (data) {

                    }
                });

                fnObj[formId] = $.extend(true, {}, objForm, fnObj[formId]);
            }
        });
    }

    // initView 존재 객체에 대한 호출
    var __executeInit = function (fnObj) {
        for (var obj in fnObj) {
            if (fnObj[obj].hasOwnProperty('initView') && typeof fnObj[obj]['initView'] === 'function') {
                fnObj[obj].initView();
            }
        }
    }

    var __initSearchViewEnter = function () {
        $('[data-ax-view-type="search"]').each(function () {
            $(this).find(':input').on('keydown', function (event) {
                if (event.keyCode == 13) {
                    ACTIONS.dispatch(ACTIONS.search);
                    event.preventDefault();
                }
            });
        });
    }

    return function (fnObj) {
        __initPageButton(fnObj);
        __initFormView(fnObj);
        __executeInit(fnObj);
        __initSearchViewEnter();
    }
})();
